import {
  searchCityById as searchCityByIdApi,
  searchCityByName as searchCityByNameApi
} from '../api';
import { anotherCity, preloadCitiesList } from '../config';
import { Env } from '@/shared/config/environment';

const state = {
  isLoadingCities: false,
};

const mutations = {
  SET_LOADING_CITIES(state, isLoading) {
    state.isLoadingCities = isLoading;
  },
};

const actions = {
  async searchCityByName({ commit, dispatch }, cityName) {
    commit('SET_LOADING_CITIES', true);

    try {
      const citiesList = await searchCityByNameApi(cityName);
      if (citiesList.length === 0) {
        return [anotherCity];
      }

      return citiesList;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося завантажити список міст';

      commit('SET_CLIENTS_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити список міст',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_CITIES', false);
    }
  },
  async searchCityById({ commit, dispatch }, cityId) {
    commit('SET_LOADING_CITIES', true);

    try {
      const citiesList = await searchCityByIdApi(cityId);
      if (citiesList.length === 0) {
        return [anotherCity];
      }

      return citiesList;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося завантажити список міст';

      commit('SET_CLIENTS_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити список міст',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_CITIES', false);
    }
  },
};

const getters = {
  isLoadingCities: state => state.isLoadingCities,

  preloadCitiesList: () => preloadCitiesList,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
